import { render, staticRenderFns } from "./LicenseCreation.vue?vue&type=template&id=0fded244&scoped=true"
import script from "./LicenseCreation.vue?vue&type=script&lang=js"
export * from "./LicenseCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fded244",
  null
  
)

export default component.exports